import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Barcode from "react-jsbarcode";
import ReactToPrint from "react-to-print";
import { createBarcodePrintList } from "../../../actions/BarcodePrintListAction";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Select,
  Divider,
  AutoComplete,
  Form,
  Button,
  Drawer,
  Table,
} from "antd";

const BarcodelistView = ({ barcodelist, reload, count, createBarcodePrintList }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const onCloseDrawer = () => {
    setDrawerVisible(false);
  };

  const columns = [
    { title: '#', dataIndex: 'serialNumber', key: 'serialNumber' },
    { title: 'Product', dataIndex: 'product', key: 'product' },
    { title: 'Variation', dataIndex: 'variation', key: 'variation' },
    { title: 'Barcode', dataIndex: 'barcode', key: 'barcode' },
    { title: 'Qty', dataIndex: 'quantity', key: 'quantity' },
  ];

  const dataSource = barcodelist.current.map((barcode, index) => ({
    key: barcode.variation.barcode,
    serialNumber: index + 1,
    product: barcode.variation.title,
    variation: barcode.variation.Attribute_details,
    barcode: barcode.variation.barcode,
    quantity: barcode.Quantity,
  }));

  const handleprinttable = (data) => {
    console.log(data);
    const formdata = new FormData();
    formdata.append("data", JSON.stringify(data));
    console.log(formdata);
    createBarcodePrintList(formdata);
  }

  const componentRef = useRef();
  useEffect(() => {
    count.current = 0;
  }, [reload]);
  const barcodes = (obj) => {
    return Array.apply(null, { length: obj.Quantity }).map((bar, index) => {
      count.current = count.current + 1;
      if (count.current % 40 == 0) {
        return (
          <>
            <Col
              style={{
                textAlign: "center",
                border: "1px solid lightgray",
                width: "20%",
              }}
              className="barcodeprint"
            >
              {/* <span style={{ marginTop: "5px", fontWeight: "900" }}>
                NUR CREATION
              </span> */}
              {console.log(obj.variation)}
              <span style={{ fontWeight: "900", fontSize: "16px", display: "block" }}>
              {obj.variation.Warehouse_name}
              </span>
              <span style={{ fontWeight: "550", marginTop: "5px", marginBottom: "5px" }}>
                {obj.variation.title} - {obj.variation.Attribute_details}
              </span>
              <span>{obj.variation.product_code}</span>
              <Barcode options={{ height: 50 }} value={obj.variation.barcode} />
              {/* <span style={{ marginTop: "-8px", fontWeight: "900" }}>
                {obj.variation.selling_price} + VAT{" "}
              </span> */}
              <span style={{ marginTop: "-5px", display: "block", }}>
                <span style={{ fontSize: "17px", fontWeight: "900", display: "inline-block" }}>{obj.variation.selling_price}</span>
                <span style={{ fontSize: "8px", fontWeight: "500", display: "inline-block" }}> (+VAT)</span>
              </span>

            </Col>
            <div class="pagebreak"> </div>

          </>
        );
      } else
        return (
          <>
            <Col
              // span={4}
              style={{
                textAlign: "center",
                border: "1px solid lightgray",
                width: "20%",
              }}
              className="barcodeprint"
            >
              {/* <span style={{ marginTop: "5px", fontWeight: "900" }}>
                NUR CREATION
              </span> */}
                            {console.log(obj.variation.Warehouse_name)}
              <span style={{ fontWeight: "900", fontSize: "16px", display: "block" }}>
              {obj.variation.Warehouse_name}
              </span>
              <span style={{ fontWeight: "550", marginTop: "5px", marginBottom: "5px" }}>
                {obj.variation.title} - {obj.variation.Attribute_details}
              </span>
              <span>{obj.variation.product_code}</span>
              <Barcode options={{ height: 50 }} value={obj.variation.barcode} />
              {/* <span style={{ marginTop: "-8px", fontWeight: "900" }}>
                {obj.variation.selling_price} + VAT{" "}
              </span> */}
              <span style={{ marginTop: "-5px", display: "block", }}>
                <span style={{ fontSize: "17px", fontWeight: "900", display: "inline-block" }}>{obj.variation.selling_price}</span>
                <span style={{ fontSize: "8px", fontWeight: "500", display: "inline-block" }}> (+VAT)</span>
              </span>

            </Col>
          </>
        );
    });
  };

  return (
    <>



      {/* <Drawer
        title="Barcode Information"
        placement="right"
        closable={false}
        onClose={onCloseDrawer}
        visible={drawerVisible}
        width={500}
      >
        <Button type="primary" onClick={() => handleprinttable(dataSource)}>Save</Button>
        <Table columns={columns} dataSource={dataSource} pagination={false} />
      </Drawer> */}




      <Row>
        <Col span={16}>
          <ReactToPrint
            trigger={() => <Button type="primary">Print this out!</Button>}
            content={() => componentRef.current}
          />
          <div ref={componentRef} >
            <Row>
              {barcodelist.current.map((barcode) => {
                return barcodes(barcode);
              })}
            </Row>
          </div>
        </Col>
        <Col span={7} offset={1}>
          {/* <Button
            type="primary"
            onClick={showDrawer}
            style={{ marginBottom: "10px", float: "right" }}
          >
            Print Barcode
          </Button> */}
          <Button type="primary" style={{ float: "right" }} onClick={() => handleprinttable(dataSource)}>Save</Button>
          <Table columns={columns} dataSource={dataSource} pagination={false} />
        </Col>
        {/* <Col span={8}>
          <table className="history_table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Variation</th>
                <th>Barcode</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              {barcodelist.current.map((barcode, index) => {
                return (
                  <tr key={index} style={{ textAlign: "center" }}>
                    <td>{barcode.variation.title}</td>
                    <td>{barcode.variation.Attribute_details}</td>
                    <td>{barcode.variation.barcode}</td>
                    <td>{barcode.Quantity}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Col> */}
      </Row>
    </>
  );
};

export default connect(null, { createBarcodePrintList })(BarcodelistView);